"use strict";
/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARRAY_FIELD_DATA_IDS = void 0;
/**
 * The data-ids used for array fields.
 */
exports.ARRAY_FIELD_DATA_IDS = {
    addItemToPrimitiveArray: 'Array Field: Array of Primitives: Add item',
    arrayOfPrimitives: 'Array Field: Array of Primitives',
};
